<template>
  <section
    ref="section10"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="11"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
          <div><v-icon icon="chair" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mb-3 mr-6 text-heading-3-desktop">
              Kako je opremljena vaša nepremičnina?
            </div>
            <div class="text-body-regular text-black-40">
              Izberete lahko samo eno možnost.
            </div>
          </div>

          <v-lightbox is-authenticated footerless>
            <template v-slot:trigger>
                <div
                    class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                >
                    <v-icon icon="question-mark" size="4"></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <div class="flex items-start">
                    <v-icon
                        icon="question-mark"
                        class="mr-2.5"
                        size="4.5"
                    ></v-icon>
                    <div>
                        Dodatne informacije
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <p class="mb-[10px] text-icon-text-medium">
                    Opremljenost nepremičnine
                </p>
                <p class="text-body-regular">
                    Med možnostmi izberite, ali je vaša nepremičnina:
                </p>
                <ul class="mb-8 text-body-regular list-disc pl-6">
                  <li>
                    neopremljena (stanovanje nima pohištva)
                  </li>
                  <li>
                    delno opremljena (stanovanje ima le del pohištva, vendar bo kupec potreboval dokupiti pohištvo za celostno opremljeno nepremičnino)
                  </li>
                  <li>
                    opremljeno (stanovanje je polno opremljeno in primerno za takojšnje bivanje)
                  </li>
                </ul>

                <p class="mb-[10px] text-icon-text-medium">
                    Delno opremljeno ali opremljeno
                </p>
                <p class="mb-4 text-body-regular">
                    Če izberete "delno opremljeno" ali "opremljeno", vas prosimo, da kasneje pri opish nepremičnine v prostem besedilu opišete, kako je stanovanje opremljeno, katero pohištvo je v nepremičnini in v kakšnem stanju je. Tako zainteresirana stranka dobi boljši pregled, kaj bi še potrebovala.
                </p>
            </template>
          </v-lightbox>
        </figure>
        <figure class="lg:-mx-10">
          <form method="POST" :action="routes.submitForm" id="select-estate-equipment">
            <v-csrf-token></v-csrf-token>
            <figure
              class="grid grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-4 lg:gap-6"
            >
              <div
                name="neOpremljeno"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[254px]', (validationErrors.ind_2028_Feld_ObjAusstattung39 ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="ind_2028_Feld_ObjAusstattung39"
                  id="kakoJeOpremljenaVasaNepremicnina-neopremljeno"
                  value="ind_Schl_3131"
                  class="hidden"
                  v-model="estateEquipment"
                />

                <label
                  for="kakoJeOpremljenaVasaNepremicnina-neopremljeno"
                  class="flex min-h-[144px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all lg:min-h-[254px]"
                >
                  <img
                    :src="$assetsUrl +'/images/neopremljeno.webp'"
                    alt="Neopremljeno"
                    class="pointer-events-none mb-4 min-h-[90px] w-[90px] select-none transition-all lg:w-40"
                  />

                  <span class="pointer-events-none select-none">Neopremljeno</span>
                </label>
              </div>
              <div
                name="delnoOpremljeno"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[254px]', (validationErrors.ind_2028_Feld_ObjAusstattung39 ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="ind_2028_Feld_ObjAusstattung39"
                  id="kakoJeOpremljenaVasaNepremicnina-desnoOpremljeno"
                  value="ind_Schl_3133"
                  class="hidden"
                  v-model="estateEquipment"
                />

                <label
                  for="kakoJeOpremljenaVasaNepremicnina-desnoOpremljeno"
                  class="flex min-h-[144px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all lg:min-h-[254px]"
                >
                  <img
                    :src="$assetsUrl +'/images/delno-opremljeno.webp'"
                    alt="Delno opremljeno"
                    class="pointer-events-none mb-4 min-h-[90px] w-[90px] select-none transition-all lg:w-40"
                  />

                  <span class="pointer-events-none select-none"
                    >Delno opremljeno</span
                  >
                </label>
              </div>
              <div
                name="opremljeno"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[254px]', (validationErrors.ind_2028_Feld_ObjAusstattung39 ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="ind_2028_Feld_ObjAusstattung39"
                  id="kakoJeOpremljenaVasaNepremicnina-opremljeno"
                  value="ind_Schl_3135"
                  class="hidden"
                  v-model="estateEquipment"
                />

                <label
                  for="kakoJeOpremljenaVasaNepremicnina-opremljeno"
                  class="flex min-h-[144px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all lg:min-h-[254px]"
                >
                  <img
                    :src="$assetsUrl +'/images/opremljeno.webp'"
                    alt="Opremljeno"
                    class="pointer-events-none mb-4 min-h-[90px] w-[90px] select-none transition-all lg:w-40"
                  />

                  <span class="pointer-events-none select-none">Opremljeno</span>
                </label>
              </div>
            </figure>
          </form>
        </figure>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-estate-equipment')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      estateEquipment: null,
    };
  },
  mounted() {
    this.estateEquipment = this.stepData.ind_2028_Feld_ObjAusstattung39
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
  computed: {
    validated() {
      if(!this.estateEquipment) return false
      
      return true;
    }
  },
};
</script>